import NotFound from "pages/common/notFound";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Profile from "./profile";
import Schedulelist from "./schedulelist";
import Past from "./past";
import Favorite from "./favorite";
import MyReservation from "pages/reservation/myReservation";

/**
 * 파일명: Mypage.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: 마이페이지 router
 */
function Mypage() {
  return (
    <Routes>
      {/* <Route path="/schedule" element={<Schedulelist />} /> */}
      <Route path="/schedule" element={<MyReservation />} />
      <Route path="/past" element={<Past />} />
      <Route path="/favorite" element={<Favorite />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Mypage;
